import { EventParams } from '../contracts';
import { sanitizeMerchantRedirectUrl } from './sanitize-merchant-redirect-url';

export const assignMerchantRedirect = (url: string | null | undefined): boolean => {
  const safeUrl = sanitizeMerchantRedirectUrl(url);
  if (!safeUrl) return false;
  window.location.href = safeUrl;
  return true;
};

export const getRedirectUrlWithStatus = (url: string, status: string): string | null => {
  const safeUrl = sanitizeMerchantRedirectUrl(url);
  if (!safeUrl) return null;
  const separator = safeUrl.includes('?') ? '&' : '?';
  return `${safeUrl}${separator}status=${status}`;
};

export const getRedirectUrlWithEventParams = (
  url: string,
  status: string,
  eventParams: Partial<EventParams> & { purchaseId?: string },
): string | null => {
  const safeUrl = sanitizeMerchantRedirectUrl(url);
  if (!safeUrl) return null;
  const urlObj = new URL(safeUrl);

  urlObj.searchParams.set('status', status);

  if (eventParams.date) urlObj.searchParams.set('date', eventParams.date);
  if (eventParams.sessionId) urlObj.searchParams.set('sessionId', eventParams.sessionId);
  if (eventParams.bundleName) urlObj.searchParams.set('bundleName', eventParams.bundleName);
  if (eventParams.bundleId) urlObj.searchParams.set('bundleId', eventParams.bundleId);
  if (eventParams.bundleSKU) urlObj.searchParams.set('bundleSKU', eventParams.bundleSKU);
  if (eventParams.totalSum !== undefined)
    urlObj.searchParams.set('totalSum', String(eventParams.totalSum));
  if (eventParams.totalSumCurrency)
    urlObj.searchParams.set('totalSumCurrency', eventParams.totalSumCurrency);
  if (eventParams.userId) urlObj.searchParams.set('userId', eventParams.userId);
  if (eventParams.userCountry) urlObj.searchParams.set('userCountry', eventParams.userCountry);
  if (eventParams.paymentMethodName)
    urlObj.searchParams.set('paymentMethodName', eventParams.paymentMethodName);
  if (eventParams.orderId) urlObj.searchParams.set('orderId', eventParams.orderId);
  if (eventParams.purchaseId) urlObj.searchParams.set('purchaseId', eventParams.purchaseId);
  if (eventParams.promoCode?.name) urlObj.searchParams.set('promoCode', eventParams.promoCode.name);
  if (eventParams.isSavedPaymentMethodUsed !== undefined) {
    urlObj.searchParams.set(
      'isSavedPaymentMethodUsed',
      String(eventParams.isSavedPaymentMethodUsed),
    );
  }
  if (eventParams.isNewPaymentMethodSaved !== undefined) {
    urlObj.searchParams.set('isNewPaymentMethodSaved', String(eventParams.isNewPaymentMethodSaved));
  }
  if (eventParams.products)
    urlObj.searchParams.set('products', JSON.stringify(eventParams.products));

  return urlObj.toString();
};
